/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { StudentEvaluationFeedbackReason } from './studentEvaluationFeedbackReason';
import type { StudentEvaluationFeedbackCategory } from './studentEvaluationFeedbackCategory';

/**
 * Feedback from the student on an AI evaluation.
 */
export interface StudentEvaluationFeedback {
  /** Whether the student found the evaluation helpful */
  isHelpful: boolean;
  /** Optional text or structured reason for the feedback */
  reason?: StudentEvaluationFeedbackReason;
  /** Structured not-helpful category when the student chose a preset reason */
  category?: StudentEvaluationFeedbackCategory;
}
